<nb-toggle status="success" type="checkbox" [checked]="isActive" (change)="onToggle($event.target.checked)">
    
</nb-toggle>

